import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

type Ctx = { title: string; setTitle: (v: string) => void };
const PageHeaderContext = createContext<Ctx | undefined>(undefined);

export const PageHeaderProvider = ({ children }: { children: ReactNode }) => {
  const [title, setTitle] = useState('');
  const value = useMemo(() => ({ title, setTitle }), [title]);
  return <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>;
};

export const usePageHeader = () => {
  const ctx = useContext(PageHeaderContext);
  if (!ctx) throw new Error('usePageHeader must be used within PageHeaderProvider');
  return ctx;
};
